import get from 'lodash/get.js';
import uniq from 'lodash/uniq.js';
// import isArray from 'lodash/isArray';

export const toHTML = (text) => {
  const parser = new DOMParser();
  return parser.parseFromString(text, 'text/xml');
}

/**
 * @summary Get hydrated text from a template
 * @param {String} template
 * @param {Object} data
 * @return {String}
 */
export const fromTemplate = (template, data ={}) => {
  return template.replace(/\{([^}]+)\}/g, (match, key) => get(data, key));
  // return output;
}

/**
 * @summary Parse a JSON object for syntax highlighting
 * @param {object} json
 * @return {*|string}
 */
export function syntaxHighlight(json) {
  if (!json) return ""; //no JSON from response

  json = json
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function (match) {
      let cls = "number";
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = "key";
        } else {
          cls = "string";
        }
      } else if (/true|false/.test(match)) {
        cls = "boolean";
      } else if (/null/.test(match)) {
        cls = "null";
      }
      return '<span class="' + cls + '">' + match + "</span>";
    }
  );
}

export function transformer({tableDepth = 3, defaultDisplayedFields = []}) {
  const flatten = (recordKey, rawValue, depth = 1) => {
    if (depth > tableDepth) {
      return Array.isArray(rawValue) ?
        rawValue :
        {[recordKey]: rawValue};
    }

    switch (true) {
      case (rawValue == null): {
        return {};
      }
      case Array.isArray(rawValue): {
        const array = rawValue.reduce(($acc, item) => {
          if (item && item !== undefined) {
            $acc.push(typeof item === "string" ?
              item :
              flatten(recordKey, item, depth + 1));
          }
          return $acc;
        }, []);
        return array.length ? array : null;
      }
      case (typeof rawValue === "object"): {
        return ((defaultDisplayedFields?.length && !recordKey) ?
          uniq([...defaultDisplayedFields, "key", "objectID"])
          .reduce(($acc, key) => {
            $acc.push([key, get(rawValue, key)]);
            return $acc;
          }, []) :
          Object.entries(rawValue)
        )
        .reduce(($acc, [key, value]) => {
          const longKey = [recordKey, key].filter(Boolean).join(".");
          const flatRecord = flatten(longKey, value, depth + 1);
          const payload = Array.isArray(flatRecord) ?
            {[longKey]: flatRecord} :
            flatRecord;

          return {...$acc, ...payload};
        }, {});
      }
      default: {
        if (rawValue === undefined) {
          return null;
        }
        return {[recordKey]: rawValue};
      }
    }
  };

  return {
    flatten,
  }
}

// export const flattenRecord = (recordKey, rawValue) => {
//   switch (true) {
//     case (rawValue == null): {
//       return {};
//     }
//     case isArray(rawValue): {
//       // console.log("Array:recordKey:", recordKey, JSON.stringify(rawValue, null, 2));
//       const array = rawValue.reduce(($acc, item) => {
//         if (item && item !== undefined) {
//           $acc.push(typeof item === "string" ? item : flattenRecord(recordKey, item));
//         }
//         return $acc;
//       }, []);
//       return array.length ? array : null;
//     }
//     case (typeof rawValue === "object"): {
//       return Object.entries(rawValue)
//       .reduce(($acc, [key, value]) => {
//         if (value !== undefined && value != null) {
//           const longKey = [recordKey, key].filter(Boolean).join(".");
//           const flatRecord = flattenRecord(longKey, value);
//           const payload = isArray(flatRecord) ?
//             {[longKey]: flatRecord} :
//             flatRecord;
//
//           return {...$acc, ...payload};
//         }
//         return $acc;
//       }, {});
//     }
//     default: {
//       if (rawValue === undefined) {
//         return null;
//       }
//       return {[recordKey]: rawValue};
//     }
//   }
// };
